import { render, staticRenderFns } from "./addNewProduct.vue?vue&type=template&id=06cf2976&scoped=true"
import script from "./addNewProduct.vue?vue&type=script&lang=js"
export * from "./addNewProduct.vue?vue&type=script&lang=js"
import style0 from "./addNewProduct.vue?vue&type=style&index=0&id=06cf2976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf2976",
  null
  
)

export default component.exports